
import { Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { LocalStorageService } from '@app/services/local-storage.service';

@Component({
  selector: 'app-public-layout',
  imports: [RouterOutlet, RouterLink],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss',
})
export class PublicLayoutComponent {
  readonly localStorage = inject(LocalStorageService);
  year = new Date().getFullYear();
  userLoggedIn = this.localStorage.isLoggedIn();
}
